import PropTypes from "prop-types";

import { bagTabs } from "actions/bag-actions";

export const bagTabPropType = PropTypes.oneOf(Object.values(bagTabs));
